let loaded = false;

function findAndAttachClickEvent() {
    var buttons = document.querySelectorAll('.variant-button');
    console.log('button length: ' + buttons.length);

    if (buttons.length === 0 && !loaded) {
        setTimeout(findAndAttachClickEvent, 400);
        return;
    }

    buttons.forEach(function (button) {
        button.addEventListener('click', function () {
            buttons.forEach(function (btn) {
                btn.classList.remove('selected');
            });
            button.classList.add('selected');

            // Update the selected variant input (assuming you have a hidden input to keep track of the selected variant)
            var selectedVariantId = button.getAttribute('data-variant-id');
            document.querySelector('.product-form input[name="id"]').value = selectedVariantId;
        });
    });

    loaded = true;
};

document.addEventListener('DOMContentLoaded', function () {
    console.log('findAndAttachClickEvent')
    findAndAttachClickEvent();
});

setTimeout(function () {
    if (!loaded) {
        findAndAttachClickEvent();
    }

}, 1000);
setTimeout(function () {
    if (!loaded) {
        findAndAttachClickEvent();
    }

}, 3000);
setTimeout(function () {
    if (!loaded) {
        findAndAttachClickEvent();
    }

}, 5000);


window.addEventListener('planChanged', function ({ detail }) {
    // look for all `.variant-button` elements and hide any nested `.selling_plan_allocation_label` elements unless the id = detail
    const buttons = document.querySelectorAll('.variant-button');
    buttons.forEach(function (button) {
        const allocationLabels = button.querySelectorAll('.selling_plan_allocation_label');
        allocationLabels.forEach(function (allocationLabel) {
            // console.log(allocationLabel.id, `selling_plan_${detail}`, !detail, allocationLabel.id === 'selling_plan_onetime')
            if (allocationLabel.id === `selling_plan_${detail}` || (!detail && allocationLabel.id === 'selling_plan_onetime')) {
                allocationLabel.style.display = 'block';
            } else {
                allocationLabel.style.display = 'none';
            }
        });
    });
});